// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"9d8c80a3","390":"7ca0d3c3"}[chunkId] + ".css";
};